import React, { useState, useRef } from 'react';
import { IoVolumeMute, IoVolumeHigh } from "react-icons/io5";
import { FaChevronDown } from "react-icons/fa6";
import { HashLink } from 'react-router-hash-link';
import { MdReplay } from "react-icons/md";

const VideoSection = () => {
    const [isMuted, setIsMuted] = useState(true);
    const [showReplay, setShowReplay] = useState(false);
    const videoRef = useRef(null);

    const toggleMute = () => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };

    const handleReplay = () => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.currentTime = 0;
            videoElement.play();
            setShowReplay(false);
        }
    };

    const handleVideoEnd = () => {
        setShowReplay(true);
    };

    return (
        <div className="position-relative video-outer" id='hero'>
            <video
                ref={videoRef}
                src="https://d2bxnt3cp18qf5.cloudfront.net/S01_Polaris_Area_99_Trailer_15_Paid_NO_RATING_16x9_2.mp4"
                autoPlay
                muted={isMuted}
                playsInline
                onEnded={handleVideoEnd}
                className="w-100"
            >
                Your browser does not support the video tag.
            </video>

            <button
                onClick={toggleMute}
                className="btn bg-dark position-absolute end-0 m-3"
                style={{ top: "10px" }}
            >
                {isMuted ? <IoVolumeMute className='text-white' /> : <IoVolumeHigh className='text-white' />}
            </button>

            {showReplay && (
                <button
                    onClick={handleReplay}
                    className="d-flex align-items-center border-0 justify-content-center position-absolute"
                    style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)",backgroundColor:"rgba(63, 63, 63,0.6)",height:"70px",width:"70px",borderRadius:"60%" }}
                >
                    <MdReplay className='text-white' size={40} />
                </button>
            )}

            <HashLink
                className="btn bg-transparent position-absolute end-0 m-3 scroll-icon"
                style={{ left: 0, right: 0 }}
                to={`#gleam_competition`}
            >
                <FaChevronDown size={30} className='text-white scroll-icon' />
            </HashLink>
        </div>
    );
};

export default VideoSection;
